import { render, staticRenderFns } from "./account.vue?vue&type=template&id=84d7ab0c&scoped=true&"
import script from "./js/account.js?vue&type=script&lang=js&"
export * from "./js/account.js?vue&type=script&lang=js&"
import style0 from "./account.vue?vue&type=style&index=0&id=84d7ab0c&lang=scss&scoped=true&"
import style1 from "./account.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d7ab0c",
  null
  
)

export default component.exports